import { createContext } from 'react';
import { Breadcrumb } from './CrumbContext';

interface CrumbContextType {
  addCrumb: (crumb: Breadcrumb, location: string) => void;
  crumbs: Breadcrumb[];
}

export const CrumbContext = createContext<CrumbContextType | undefined>(
  undefined,
);
